import { render, staticRenderFns } from "./orderStatementEditPage.vue?vue&type=template&id=68947ac0&"
import script from "./orderStatementEditPage.vue?vue&type=script&lang=ts&"
export * from "./orderStatementEditPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports